import { id, root } from './details';

export const details = {
  ...root,
  id,
};
